<div class="container my-4">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Manage Referrals</span>
    </div>
  </div>
  <div class="card card_content">
    <div class="row d-flex  align-items-center flex-wrap grid-margin mb-2">
      <div class="col-md-3">
        <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
          <i class="fa fa-refresh"></i> Refresh
        </button> -->
        <app-button (refreshClicked)="clearFilter()"></app-button>

        <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
          <i class="fa fa-file-excel"></i> Export
        </button>
      </div>
      <div class="col-md-4 padd-right-file" style="display: flex;">
        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
          <mat-label>Search</mat-label>
          <div class="search-input-container">
            <input placeholder="Enter Name/ Email/ Application Number/ Status " id="search" matInput
              (keyup)="applyFilter($event)" type="text" #searchInput>
          </div>
        </mat-form-field>
        <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
          (click)="applyFilter($event)">
          <mat-icon style="color: white;">search</mat-icon>
        </button>

      </div>
      <div class="col-md-4 d-flex">
        <button type="button" class="btn btn-primary  d-flex" (click)="filterOpen = !filterOpen">
          <ng-container *ngIf="!filterOpen">
            <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
          </ng-container>
          <ng-container *ngIf="filterOpen">
            <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
          </ng-container>
          <span class="ml-2">Filters</span>
        </button>
        <!-- <button type="button" class="btn btn-primary  d-flex ml-4" (click)="excelUploadOpen = !excelUploadOpen">
          <ng-container *ngIf="!excelUploadOpen">
            <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
          </ng-container>
          <ng-container *ngIf="excelUploadOpen">
            <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
          </ng-container>
          <span class="ml-2">Upload Paid Users</span>
        </button> -->

      </div>

    </div>

    <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
      <hr>
      <form [formGroup]="filterSearchForm">
        <div class="row mx-5">
          <div class="col-xl-6 mt-4">
            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
              <mat-label>Start Date</mat-label>
              <input readonly matInput appInputtext [matDatepicker]="startDate" formControlName="startDate"
                selectable="isSelectable(date,type)" id="startDate" autocomplete="off"
                placeholder="Please Select Application From Date" class="custom-input-border" specialIsAlphaNumeric>
              <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                <button mat-icon-button>
                  <mat-icon>event</mat-icon>
                </button>
              </mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-xl-6 mt-4">
            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
              <mat-label>End Date</mat-label>
              <input readonly matInput appInputtext [matDatepicker]="endDate" formControlName="endDate"
                selectable="isSelectable(date,type)" id="endDate" autocomplete="off"
                placeholder="Please Select Application To Date" class="custom-input-border" specialIsAlphaNumeric>
              <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                <button mat-icon-button>
                  <mat-icon>event</mat-icon>
                </button>
              </mat-datepicker-toggle>
              <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-xl-12 mt-5 d-flex justify-content-center">
          <button class="btn reset_btn mr-3 btn_danger" (click)="clearFilter()">
            Reset
          </button>
          <button class="btn btn-secondary mr-3 btn_danger" (click)="searchClick()">
            <i class="fa fa-search mr-2"></i>Search
          </button>
        </div>
      </form>
    </div>

    <!-- <div [@detailExpand]="excelUploadOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
      <hr>
      <form [formGroup]="form">
        <div class="row  mt-3 d-flex   align-items-center flex-wrap grid-margin  justify-content-center">
          <div class="col-xl-9 d-flex align-items-center justify-content-center flex-wrap grid-margin">
            <div class="col-7">
              <div class="padd-right-file" style="display: flex;">
                <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                  <mat-label>Attachment</mat-label>
                  <input matInput id="AttachmentFileName" placeholder="Select Attachment"
                    formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric class="col-10"
                    autocomplete="off" readonly>
                </mat-form-field>
                <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                  class="badge bg-light-blue image-button">
                  <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;" />
                </button>
                <button type="button" (click)="reset()" *ngIf="isFileSelected" class="badge bg-light-blue image-button">
                  <img style="filter: invert(1);width: 26px;" src="../../../../assets/Home-Connect/icons/delete.svg" />
                </button>
              </div>

            </div>
            <div class="d-flex button-style mt-3">
              <button class="btn btn-primary mb-3 ml-3" type="submit" (click)="upload()" matButton>Submit</button>
            </div>
          </div>
          <small class="form-text text-muted" style="font-size: 14px;">
            <strong>Note:</strong> Export the list using the <strong>Export</strong> option and upload the file with
            payment status updated for
            paid users only.
          </small>

        </div>
      </form>
    </div> -->


    <div class="table-responsive mt-2 mb-4">
      <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

        <ng-container matColumnDef="ReferrerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ReferrerName">Referrer Name</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign"> {{dataField.existingUserName}}</p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ReferrerEmail">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ReferrerEmail">Referrer Email</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.existingUserEmail}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReferralType">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ReferralType" >Referral
            Type</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="txtalign">{{dataField.referralTypeName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReferredCustomerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ReferredCustomerName" >Referee
            Name</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.newUserFirstName}} {{dataField.newUserLastName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReferredCustomerEmail">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ReferredCustomerEmail">Referee Email</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="txtalign">{{dataField.newUserEmail}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RefereeCustomerContactNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header="RefereeCustomerContactNumber" >Referee<br>
            Mobile Number</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="txtalign">{{dataField.newUserMobileNumber}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RefereeApplicationNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header="RefereeApplicationNumber">Referee Application
            Number</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.referenceNumber}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReferralStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ReferralStatus">Referral Status</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <p class="text-truncate txtalign">{{dataField.customerReferralStatus}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Action">
          <mat-header-cell *matHeaderCellDef mat-sort-header="Action">Action</mat-header-cell>
          <mat-cell *matCellDef="let dataField">
            <div class="text-truncate text-center">
              <!-- <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-check-circle mr-3"
              title="Mark as paid" (click)="MarkAsPaidd(dataField.id)"
              *ngIf="dataField.customerReferralStatus=='Completed'"></i> -->
              <!-- Show plain text when promotionStatus == 6 -->
              <span *ngIf="dataField.customerReferralStatus == 'Paid'" class="paid-text">PAID</span>

              <!-- Otherwise show the button -->
              <button *ngIf="dataField.customerReferralStatus == 'Completed' && dataField.referralType == ReferralTypeEnum.VumatelReferral" class="credit-btn"
                (click)="MarkAsPaidd(dataField.id)">
                PAY CREDIT
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
        </mat-row>
      </mat-table>
      <div *ngIf="data.length == 0" class="no-data-message">
        <p>No data found</p>
      </div>
    </div>


    <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
      <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
        [pageSizeOptions]="[50, 100]">
      </mat-paginator>
    </div>
  </div>
</div>